const MultiSelectFieldComponent = {
    templateUrl: '/formViewer/component/multiSelect/multiSelect.tpl.html',
    controller: 'multiSelectFieldController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umCore')
    .component('uiMultiSelectField', MultiSelectFieldComponent);
